import { getTvObject, tv } from '@costar-ui/cosmos';

var modalTV = getTvObject({
  base: ['flex', 'max-h-full', 'w-full', 'min-w-80', 'overflow-hidden', 'rounded-sm border', 'border-neutral/10 bg-base', 'bg-clip-padding', 'text-left', 'align-middle', 'text-on-base', 'shadow-elevation-35',
  // 'backdrop-blur-2xl',
  // 'backdrop-saturate-200',
  'forced-colors:bg-[Canvas]', 'print:w-full', 'print:max-w-full', 'print:overflow-visible', 'print:border-none', 'print:backdrop-saturate-0', 'print:bg-clip-content', 'print:shadow-none'
  // 'print:backdrop-blur-none'
  ],
  variants: {
    size: {
      fit: 'max-w-fit',
      sm: 'max-w-screen-sm',
      std: 'max-w-screen-md',
      lg: 'max-w-screen-lg',
      xl: 'max-w-screen-xl'
    },
    fullHeight: {
      "true": ['h-full', 'print:max-h-max']
    }
    // Animation is currently not defined in Cosmos 2.0
    //isEntering: {
    // true: ['duration-200', 'ease-out', 'animate-in', 'zoom-in-105']
    //},
    // isExiting: {
    //   true: ['duration-200', 'ease-in', 'animate-out', 'zoom-out-95']
    // }
  }
});
var base = tv(modalTV);
var modalStyles = {
  base: base
};

export { modalStyles, modalTV };
//# sourceMappingURL=modal.styles.esm.js.map
